/**
 * Redactions – single tab that groups PDF Viewers and LLM Redactions as sub-tabs.
 */
import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import PdfViewersTab from './PdfViewersTab';
import LlmRedactionsTab from './LlmRedactionsTab';

const SUB_TABS = [
  { id: 'pdf-viewers', label: 'PDF Viewers', component: PdfViewersTab },
  { id: 'llm-redactions', label: 'LLM Redactions', component: LlmRedactionsTab },
];

const RedactionsTab = ({ projectId }) => {
  const [subTab, setSubTab] = useState(SUB_TABS[0].id);
  const ActiveSub = SUB_TABS.find((t) => t.id === subTab)?.component || PdfViewersTab;

  return (
    <Box>
      <Tabs
        value={subTab}
        onChange={(_, value) => setSubTab(value)}
        indicatorColor="primary"
        textColor="primary"
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
      >
        {SUB_TABS.map((tab) => (
          <Tab key={tab.id} label={tab.label} value={tab.id} />
        ))}
      </Tabs>
      <ActiveSub projectId={projectId} />
    </Box>
  );
};

export default RedactionsTab;
